import parsePhoneNumberFromString, { formatIncompletePhoneNumber } from 'libphonenumber-js';
import React from 'react';
import * as Yup from 'yup';
import usePhonePrefix from '../../../../../helpers/use-phone-prefix';

export type TFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  password: string;
  repeated: string;
};

export const formSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('validation.required')
    .min(2, 'validation.min2')
    .matches(/^[^<>~?!>@#$%^*()_+=0-9]*$/, 'validation.only_letters'),
  lastName: Yup.string()
    .required('validation.required')
    .min(2, 'validation.min2')
    .matches(/^[^<>~?!>@#$%^*()_+=0-9]*$/, 'validation.only_letters'),
  email: Yup.string().required('validation.required').email('validation.email'),
  phoneNumber: Yup.string()
    .test('phone-country', 'validation.phone_format', function (v: any) {
      if (v && v.length !== 4) {
        const phone = parsePhoneNumberFromString(v);
        return phone?.isValid() || false;
      }
      return true;
    })
    .required('validation.required'),
  password: Yup.string()
    .required('validation.required')
    .min(8, 'validation.min8')
    .matches(/^(?=.*[A-Z])/, 'validation.one_uppercase')
    .matches(/^(?=.*[a-z])/, 'validation.one_lowercase')
    .matches(/^(?=.*[0-9])/, 'validation.one_number'),
  repeated: Yup.string()
    .required('validation.required')
    .test('password-match', 'validation.password_match', function (v: any) {
      return this.parent.password === v;
    }),
});

export function useInitialValues(registerData: any) {
  const phoneNumberPrefix = usePhonePrefix();

  return React.useMemo(() => {
    return {
      firstName: registerData?.firstName || '',
      lastName: registerData?.lastName || '',
      email: registerData?.email || '',
      phoneNumber: registerData?.phoneNumber
        ? formatIncompletePhoneNumber(registerData.phoneNumber)
        : '',
      password: '',
      repeated: '',
    } as TFormValues;
  }, [registerData, phoneNumberPrefix]);
}
